import { CustomerModel } from "../models/Customer";
import { CustomerUpdateRunDetailLine } from "../models/CustomerUpdateRunDetail";
import { DxDataGridColumn } from "../models/DxDataGridColumn";
import { NameValuePair } from "../models/NameValuePair";
import { Utilities } from "../utils/utilities";

export const convertDeterminantsToJsonString = (selectedCustomer: CustomerModel): string => {
  const jsonProps = {
    Determinants: [] as {
      Type: string;
      IsNumeric: boolean;
      NumericValue?: number;
      StringValue?: string;
    }[],
  };

  const determinants = selectedCustomer.DeterminantsProps;

  if (determinants) {
    for (const key in determinants) {
      if (Object.prototype.hasOwnProperty.call(determinants, key)) {
        const determinant = determinants[key];
        const isNumeric = determinant.NumericValue !== undefined;

        jsonProps.Determinants.push({
          Type: key,
          IsNumeric: isNumeric,
          NumericValue: determinant.NumericValue,
          StringValue: determinant.StringValue,
        });
      }
    }
  }

  return JSON.stringify(jsonProps);
};

export const cellValueFormatForUpdateColumn = (value: any) => {
  if (Utilities.isNullOrEmptyString(value)) {
    return "All";
  }

  var strValue = value.toString();
  if (strValue.toString() === "1") {
    return strValue + "st";
  }

  return strValue + "th";
};

export const ReviewCustomersGridColumns = [
  {
    dataField: "Name",
    caption: "Shipto Name",
    fixed: true,
    fixedPosition: "left",
    cssClass: "fixed-column-style",
  },
  {
    dataField: "SurchargeType",
    caption: "Surcharge Type",
  },
  {
    dataField: "PrimarySalesRep",
    caption: "Primary Sales Rep",
  },
  {
    dataField: "Formula",
    caption: "Formula Type",
  },
  {
    dataField: "Plant",
    caption: "Source",
  },
  {
    dataField: "Region",
    caption: "Region",
  },
  {
    dataField: "ProductType",
    caption: "Product Line",
  },
  {
    dataField: "DeterminantsProps['Base NG']",
    caption: "Base NG",
    cellRenderCaption: "Base NG",
  },
  {
    dataField: "DeterminantsProps['Base Milage']",
    caption: "Base Milage",
    cellRenderCaption: "Base Milage",
  },
  {
    dataField: "DeterminantsProps['NG Efficiency']",
    caption: "NG Efficiency",
    cellRenderCaption: "NG Efficiency",
  },
  {
    dataField: "DeterminantsProps['SpecPower']",
    caption: "Spec Power",
    cellRenderCaption: "SpecPower",
  },
  {
    dataField: "DeterminantsProps['Diesel']",
    caption: "Diesel",
    cellRenderCaption: "Diesel",
  },
  {
    dataField: "DeterminantsProps['DieselRecovery']",
    caption: "DieselRecovery",
    cellRenderCaption: "DieselRecovery",
  },
  {
    dataField: "Frequency",
    caption: "Frequency",
  },
  {
    dataField: "Currency",
    caption: "Currency",
  },
  {
    dataField: "Multiplier",
    caption: "Multiplier",
  },
  {
    dataField: "UpdateEx",
    caption: "Update",
  },
  {
    dataField: "SalesOrg",
    caption: "Sales Org",
  },
  {
    dataField: "SAPMaterialProductCode",
    caption: "SAP Material Product Code",
  },
  {
    dataField: "SAPEnergySurchargeCode",
    caption: "SAP Surcharge Code",
  },
  {
    dataField: "Unit",
    caption: "Unit",
  },
  {
    dataField: "Uom",
    caption: "UOM",
  },
  {
    dataField: "DeterminantsProps['NOLA Tax']",
    caption: "NOLA Tax",
    cellRenderCaption: "NOLA Tax",
  },
  {
    dataField: "IncludeInNewSurchargeEvents",
    caption: "Active",
  },
  {
    dataField: "SurchargeStartDate",
    caption: "Surcharge Start Date",
  },
  {
    dataField: "LatestNoteText",
    caption: "Comment",
  },
] as DxDataGridColumn[];

export const RunHistoryLogDetailColumns = [
  {
    dataField: "shipTo",
    caption: "Ship To",
  },
  {
    dataField: "action",
    caption: "Action",
  },
  {
    dataField: "detail",
    caption: "Detail",
  },
  {
    dataField: "createdAt",
    caption: "Created",
  },
] as DxDataGridColumn[];

export const generateFilterConditions = (history: CustomerUpdateRunDetailLine[]) => {
  return [
    {
      name: `Everything${logCount("", history)}`,
      value: "",
    },
    {
      name: `SAP and LHYST Errors${logCount("Errors", history)}`,
      value: "Errors",
    },
    {
      name: `Changes${logCount("Change", history)}`,
      value: "Change",
    },
    {
      name: `Deletions${logCount("Delete", history)}`,
      value: "Delete",
    },
  ] as NameValuePair[];
};

const logCount = function (eventType: string, history: CustomerUpdateRunDetailLine[]) {
  var filteredCount = filterOnEventType(eventType, history).length;
  return filteredCount > 0 ? ` (${filteredCount})` : "";
};

export const filterOnEventType = function (eventType: string, history: CustomerUpdateRunDetailLine[]) {
  switch (eventType) {
    case "Errors":
      return history.filter((x) => ["SAP Error", "LHYST Error"].includes(x.action));
    case "":
      return history;
    default:
      return history.filter((x) => x.action === eventType);
  }
};
